module.exports = __webpack_public_path__ + "static/media/uk.f78c5663.jpeg";